var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:{
    'step--disabled': _vm.disabled,
    'step--active': _vm.active,
  },on:{"click":_vm.onClick}},[_c('div',{staticClass:"step-number",class:_vm.stepNumberClass},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"step-title",class:{
      'step-title-active': _vm.active,
    },domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }